import { Grid } from "@mui/material";

import AppLayout from "./AppLayout";
import InstanceContext from "./context/InstanceContext";
import { resolveUrl } from "../libs/utils";

function LayoutContent({ SideComp, MainComp, centered = false }) {
  const { info, languageOverrides } = InstanceContext.useInstance();
  const entityName = languageOverrides?.entity_name ?? "comune di terni";
  const logos = info?.logos || [];

  return (
    <AppLayout>
      {!centered && (
        <Grid item xs={12} md={4} lg={3}>
          <SideComp />
        </Grid>
      )}
      <Grid
        item
        xs={12}
        md={8}
        lg={9}
        p={{ sm: 0, md: 2 }}
        pt={3}
        py={{ sm: 3, md: 0 }}
        container={centered}
        justifyContent={centered ? "center" : "flex-start"}
      >
        <MainComp />
      </Grid>
      {logos.length > 0 && (
        <Grid container item xs={12} justifyContent="center" mt={5}>
          <Grid
            container
            item
            xs={11}
            justifyContent="space-evenly"
            rowSpacing={3}
          >
            {logos.map((logo, index) => {
              const mdWidth = Math.floor(12 / logos.length);
              return (
                <Grid
                  key={index}
                  item
                  xs={12}
                  md={mdWidth}
                  container
                  justifyContent="center"
                >
                  <img
                    src={resolveUrl(logo.url)}
                    alt={entityName}
                    style={{
                      objectFit: "contain",
                    }}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      )}
    </AppLayout>
  );
}

export default LayoutContent;
